import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";

import classes from './login.module.scss';
import logo from '../../../../assets/logo.png'
import Form from '../../../Forms/EnterForm';

const Login = ( {onChange}) => {

    const [value, setValue] = useState({
        "email": '',
        "password": ''
    })

    const values = useSelector(state => state.typeOfEnterSlice)

    const handleSubmit = (data) => {
        const idetifier = values.idetifier
        for (let i = 0; i < idetifier.length; i++){
            setValue(prevValues => ({
                ...prevValues,
                [idetifier[i]]: data[idetifier[i]]
            }))
        }
        onChange(value)
    }

    useEffect(()=>{
        if(value.email !== ''){
            onChange(value)
        }
    }, [value])

    return (
        <div className={classes.login}>
            <img className={classes.login__logo} src={logo} alt='logo'></img>
            <Form
            onChange={handleSubmit}
            values = {values}
            />
        </div>
        
    )
}

export default Login